<template>
    <div>
        <div v-if="currentSubscription" class="container"
            data-test-hook="update-plan-modal">
            <b-row v-if="currentSubscription" align-h="center"
                class="mb-0 pb-0 current-plan" no-gutters>
                <b-col>
                    <div align-h="around" class="row mb-3 ml-3 mr-3">
                        <p class="text-center plan-details-header" data-test-hook="current-plan-support-text">
                            {{ $t('xCurrentPlanSupport', { 0: currentSubscription.product.name }) }}
                        </p>
                    </div>
                </b-col>
            </b-row>
            <b-row no-gutters>
                <b-col cols="0" style="width:100%">
                    <SubscriptionUpgradeExistingSubCard
                        :subscriptionProduct="currentSubscription.product"
                        :apparatuses-to-update="apparatusList"
                    />
                </b-col>
            </b-row>
            <b-row no-gutters class="mt-3">
                <b-col cols="12">
                    <b-button variant="warning" class="w-100 btn btn-primary" @click="$emit('updateExistingProductApparatuses')"
                        data-test-hook="update-to-existing-sub-button">
                        {{ $t('xUpdateNow') }}
                    </b-button>
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col class="text-center">
                    <p class="text-small legal-text">*{{ $t('xPushNotificationsAreAvailableWithInstallation') }}</p>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import SubscriptionUpgradeExistingSubCard from './Common/SubscriptionUpgradeExistingSubCard.vue'

export default {
    props: ['currentSubscription', 'apparatusList'],
    emits: ['updateExistingProductApparatuses'],
    components: {
        SubscriptionUpgradeExistingSubCard
    },
}
</script>
<style lang="scss">
.current-plan {
    .plan-details-header {
        font-size: 1.125em;
        line-height: 1.25;
        font-weight: 500;
    }
}
</style>
